/**
 * Loading placeholder for the menu — three "category" stripes each
 * with a row of pulsing card-shaped boxes. Used while the menu API
 * call is in flight. Keeps the page visually anchored instead of
 * collapsing to a single line of text.
 */
export function MenuSkeleton() {
  return (
    <div className="px-4 sm:px-6 py-6 space-y-10 pb-32" aria-busy="true" aria-live="polite">
      <span className="sr-only">Loading menu…</span>
      {[0, 1, 2].map((row) => (
        <section key={row}>
          <div className="h-8 w-48 rounded bg-wca-gray-light/80 animate-pulse mb-4" />
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
            {[0, 1, 2].map((col) => (
              <div key={col} className="bg-wca-surface rounded-card shadow-card overflow-hidden">
                <div className="aspect-[5/3] bg-wca-gray-light/80 animate-pulse" />
                <div className="p-4 space-y-2">
                  <div className="h-5 w-3/4 rounded bg-wca-gray-light/80 animate-pulse" />
                  <div className="h-3 w-full rounded bg-wca-gray-light/60 animate-pulse" />
                  <div className="h-3 w-5/6 rounded bg-wca-gray-light/60 animate-pulse" />
                </div>
              </div>
            ))}
          </div>
        </section>
      ))}
    </div>
  );
}
